module.exports = __webpack_public_path__ + "static/img/resume-creative.28c13b5.png";